<!-- <mat-tab-group>
  <mat-tab label="Ett objekt"> -->
<app-headertext text="Nytt objekt" [hideback]="true"></app-headertext>
<div *ngIf="!objecttypes" style="min-height: 366px; min-width: 180px">
  <div class="center-on-screen">
    <mat-spinner></mat-spinner>
    <p>Henter objekttyper...</p>
  </div>
</div>
<form
  *ngIf="objecttypes"
  class="object-form"
  [formGroup]="Form"
  (ngSubmit)="
    create(
      name.value,
      tfmTag.value,
      rdsTag.value,
      selectedObjecttypeId(),
      desc.value,
      process.value,
      profilenumber.value
    )
  "
>
  <div class="form-scroll">
  <div class="form-group">
    <!-- <p>
      <mat-form-field>
        <input
          matInput
          id="no"
          type="number"
          placeholder="Nummer"
          formControlName="no"
        />
        <mat-error *ngIf="no.touched && no.invalid">
          <div *ngIf="!no.errors.required">Please enter a valid number</div>
          <div *ngIf="no.errors.required">
            Object number is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p> -->
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="name"
          type="text"
          placeholder="Navn"
          formControlName="name"
        />
        <mat-error *ngIf="name.touched && name.invalid">
          <div *ngIf="!name.errors.required">Please enter a object name</div>
          <div *ngIf="name.errors.required">
            Object name is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="tfmTag"
          type="text"
          placeholder="TFM Tag"
          formControlName="tfmTag"
        />
        <mat-error *ngIf="tfmTag.touched && tfmTag.invalid">
          <div *ngIf="!tfmTag.errors.required">Please enter a TFM tag</div>
          <div *ngIf="tfmTag.errors.required">
            Object name is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="rdsTag"
          type="text"
          placeholder="RDS Tag"
          formControlName="rdsTag"
        />
        <mat-error *ngIf="rdsTag.touched && rdsTag.invalid">
          <div *ngIf="!rdsTag.errors.required">Please enter a RDS Tag</div>
          <div *ngIf="rdsTag.errors.required">
            Object name is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <p class="objecttype-picker-row">
      <label class="treeselect-label">Objekttype</label>
      <p-treeSelect
        formControlName="type"
        [options]="objecttypeTree"
        selectionMode="single"
        [filter]="true"
        filterBy="label"
        filterPlaceholder="Søk objekttype"
        [showClear]="true"
        placeholder="Velg objekttype"
        appendTo="body"
        [overlayOptions]="treeSelectOverlayOptions"
        containerStyleClass="objecttype-treeselect"
        panelStyleClass="objecttype-treeselect-panel"
        [style]="{ width: '100%' }"
        scrollHeight="320px"
      ></p-treeSelect>
      <mat-error class="treeselect-error" *ngIf="type.touched && type.invalid">
        Objekttype er <strong>påkrevd</strong>
      </mat-error>
    </p>
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="desc"
          type="text"
          placeholder="Beskrivelse"
          formControlName="desc"
        />
        <mat-error *ngIf="desc.touched && desc.invalid">
          <div *ngIf="!desc.errors.required">Please enter a description</div>
          <div *ngIf="desc.errors.required">
            Object description is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="process"
          type="text"
          placeholder="Prosess"
          formControlName="process"
        />
        <mat-error *ngIf="process.touched && process.invalid">
          <div *ngIf="!process.errors.required">Please enter a process</div>
          <div *ngIf="process.errors.required">
            Object process is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <p>
      <!-- <mat-icon>person_outline</mat-icon> -->
      <mat-form-field>
        <input
          matInput
          id="profilenumber"
          type="text"
          placeholder="Profilnummer"
          formControlName="profilenumber"
        />
        <mat-error *ngIf="profilenumber.touched && profilenumber.invalid">
          <div *ngIf="!profilenumber.errors.required">
            Please enter a profilenumber
          </div>
          <div *ngIf="profilenumber.errors.required">
            Object profilenumber is <strong>required</strong>
          </div>
        </mat-error>
      </mat-form-field>
    </p>
    <mat-error color="warn" *ngIf="error">{{ error }}</mat-error>
  </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="!hideOpenAfterCreated"
      type="button"
      mat-icon-button
      class="open-after-toggle"
      (click)="toggleOpenAfterCreate()"
    >
      <mat-icon>{{
        openAfterCreate ? "check_box" : "check_box_outline_blank"
      }}</mat-icon>
      Åpne etter lagring
    </button>
    <span class="fill-space"></span>
    <button type="button" mat-button (click)="attemptClose()">Avbryt</button>
    <button mat-raised-button id="btnSubmit" [disabled]="Form.invalid">
      Lagre
    </button>
  </div>
</form>
<!-- </mat-tab>
  <mat-tab label="Flere objekter">
    <input type="file" (change)="fileChange($event)" name="file" />

    <h4 *ngIf="showMessage">{{ message }}</h4>
  </mat-tab>
</mat-tab-group> -->
